export function embedGTag(GIDs: string[]): (...args: any[]) => void {
    const _window = window as any;
    _window.dataLayer = _window.dataLayer || [];
    const gtag = function (...args: any[]) {
        // eslint-disable-next-line 
        _window.dataLayer.push(arguments);
    };

    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.async = true;
    
    GIDs.forEach(GID => {
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GID}`;
        head.appendChild(script);
    
        gtag('js', new Date());
        gtag('config', GID, {
            send_page_view: false,
            anonymize_ip: true,
            custom_map: {'dimension1': 'CRM'}
        });
    })

    return gtag;
}
